// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import authGuard from './service/auth-guard'
import dialogService from './service/dialogService'
import store from './store/index'
import { getSystemInfo } from './utils/index'
import sdkService from './service/sdkService'
Vue.prototype.dialogService = dialogService;
Vue.config.productionTip = false;


// import vConsole  from './utils/vConsole'

window.api = '/api';
window.host = location.host;
import {
  clearCache,
  checkVersion,
} from './utils/tools'

// // 检查版本
// checkVersion();
// // 清除缓存
// clearCache();
// // 获取系统信息
// getSystemInfo();

// // 配置微信分享相关内容
// router.afterEach((to, from) => {
//   sdkSignature(to, from)
// });


// 路由守卫
router.beforeEach((to, from, next) => {
  authGuard(to, from, next)
});
sdkService.jssdk(sdkService.config1);
// 配置微信分享相关内容
router.afterEach((to, from) => {
  sdkService.config1()
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});





// WEBPACK FOOTER //
// ./src/main.js